import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const RoleTabs = ({ activeRole, roles }) => {
  const navigate = useNavigate();

  const login = localStorage.getItem("user");
  const loginData = JSON.parse(login);

  const filters = useMemo(() => {
    const roleNames = (roles || []).map((role) => role.name);
    return ["All", ...roleNames].filter((role) => {
      if (role === "Admin") {
        return loginData?.is_system_admin === 1;
      }
      return true;
    });
  }, [roles, loginData]);

  const handleFilterClick = (role) => {
    const roleName = role;
    if (roleName !== "All") {
      const path = `/users/${roleName.toLowerCase().replace(/ /g, "-")}`;
      navigate(path);
    } else {
      navigate("/users/all");
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {filters.map((role) => (
        <Box
          key={role}
          sx={{
            padding: "9px 18px",
            borderRadius: "4px",
            backgroundColor: role === activeRole ? "#ECE9F1" : "#fff",
            cursor: "pointer",
          }}
          onClick={() => handleFilterClick(role)}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 500,
              color: role === activeRole ? "#252525" : "#5D6679",
            }}
          >
            {role}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default RoleTabs;
